import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './components/i18n'
import Master from './theme/AppMaster'
import './App.css'
import './environments/Global'
import './environments/API'
import { CartProvider } from './functions/context/CartProvider'
import { UserProvider } from './functions/context/UserContext'

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// Escoge el basename según entorno
const basename = isLocalhost
  ? process.env.REACT_APP_BASENAME_LOCAL
  : process.env.REACT_APP_BASENAME_PROD;

function App() {
  return (
    <CartProvider>
      <BrowserRouter basename={basename} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <UserProvider>
          <Routes>
            <Route path={global.ROUTE_HOME} name="Home" element={<Master />} />
          </Routes>
        </UserProvider>
      </BrowserRouter>
    </CartProvider>
  )
}

export default App
